// extracted by mini-css-extract-plugin
export default {"input":"CustomInput_input__wfk5F","input__icon":"CustomInput_input__icon__EsoyL"};